import { Ref, ref, computed } from "vue";
import { KoyouKeiyakuService } from "@/service/KoyouKeiyakuService";
import { KoyouKeiyakuDetail } from "@/types/KoyouKeiyakuDetail"

/*
* 雇用契約書ID（= パス）から雇用契約書の詳細を取得する
*/
export function useKoyouKeiyakuDetail() {

  let loading = ref(0)
  const isError = ref(false)

  // 詳細表示用：表示用（編集にはuseKoyouKeiyakuEditのeditingKoyouKeiyakuを使用すること）
  const keiyakuDetail: Ref<KoyouKeiyakuDetail | null> = ref(null);

  const srv = new KoyouKeiyakuService();

  const getKeiyakuDetail = async (targetId: number) => {
    loading.value++
    const keiyaku = await srv.getDetail(targetId)
    if (!keiyaku) {
      isError.value = true;
      return
    }
    keiyakuDetail.value = keiyaku;

    // time型からHourのみ切り出す
    const timeToHours = (time: string) => {
      const times = time.split(':')
      if (times.length >= 2) {
        return parseInt(times[0], 10);
      }
    };

    // time型からminutesのみ切り出す
    const timeToMiutes = (time: string) => {
      const times = time.split(':')
      if (times.length >= 2) {
        return parseInt(times[1], 10);
      }
    };

    // 週の所定労働時間からHourとminutesを切り出す 
    keiyakuDetail.value.syotei_work_week_times_hours = Number(timeToHours(String(keiyakuDetail.value.syotei_work_week_times)));
    keiyakuDetail.value.syotei_work_week_times_minutes = Number(timeToMiutes(String(keiyakuDetail.value.syotei_work_week_times)));

    // 包括時間
    keiyakuDetail.value.houkatsu_times_hours = Number(timeToHours(String(keiyakuDetail.value.houkatsu_times)));
    keiyakuDetail.value.houkatsu_times_minutes = Number(timeToMiutes(String(keiyakuDetail.value.houkatsu_times)));

    // 差し引き時間
    keiyakuDetail.value.sashihiki_times_hours = Number(timeToHours(String(keiyakuDetail.value.sashihiki_times)));
    keiyakuDetail.value.sashihiki_times_minutes = Number(timeToMiutes(String(keiyakuDetail.value.sashihiki_times)));

    loading.value--
  }

  // 時給タイプの基本給参考値を算出する（PG雇入れ連絡票の為の参考値）
  const calcKihonkyuu = computed(() => (data: KoyouKeiyakuDetail) => {
    let totalKihonkyuu = 0;
    if (data.kihonkyuu && data.syotei_work_month_times) {
      totalKihonkyuu = data.syotei_work_month_times * data.kihonkyuu;
    }
    return totalKihonkyuu;
  })

  // 賃金を合計する
  const calcSalary = computed(() => (data: KoyouKeiyakuDetail) => {
    let toatalSalary = 0

    if (!data) {
      return toatalSalary
    }

    if (data.is_jikyuu) {
      // 時給タイプの賃金合計
      toatalSalary += Number(data.syotei_work_month_times) * Number(data.kihonkyuu)
    } else {
      // 基本給タイプの賃金合計
      // console.log('kihonkyuu', typeof data.kihonkyuu)
      toatalSalary += Number(data.kihonkyuu)
    }

    // 交通費
    // console.log('koutsuuhi', typeof data.koutsuuhi)
    toatalSalary += Number(data.koutsuuhi)
   
    // console.log('koutsuuhi_kazei', typeof data.koutsuuhi_kazei)
    toatalSalary += Number(data.koutsuuhi_kazei)

    // 手当
    if (data.teates) {
      data.teates.forEach(function (teate) {
        // console.log('teate', typeof teate)
        toatalSalary += Number(teate.kingaku)
      })
    }

    // 残業（見込み）
    // console.log('zangyou_mikomi', typeof data.zangyou_mikomi)
    toatalSalary += Number(data.zangyou_mikomi)

    // console.log('toatalSalary', typeof toatalSalary)
    return toatalSalary
  });


  // 読み込み中か判断する
  let isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    isError,
    keiyakuDetail,
    isLoading,
    getKeiyakuDetail,
    calcSalary,
    calcKihonkyuu
  }
}

